import { Box, Paper, Typography } from '@mui/material';
import { b2bColors } from '../styles/b2bTheme';

/**
 * Shared layout for /login, /activate, /forgot-password, /reset-password.
 * Split view on desktop, single column on mobile.
 */
export default function AuthShell({ title, subtitle, children }) {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            }}
        >
            {/* Brand panel — hidden on mobile to save viewport */}
            <Box
                sx={{
                    display: { xs: 'none', md: 'flex' },
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    px: 6,
                    py: 5,
                    backgroundColor: b2bColors.primary,
                    color: '#fff',
                }}
            >
                <Typography variant="h3" sx={{ color: '#fff', fontWeight: 700 }}>
                    Amabec <Box component="span" sx={{ opacity: 0.7, fontWeight: 400 }}>B2B</Box>
                </Typography>
                <Box>
                    <Typography variant="h1" sx={{ color: '#fff', maxWidth: 420, lineHeight: 1.2 }}>
                        Vos commandes récurrentes, sans décrocher le téléphone.
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.78)', mt: 2, maxWidth: 420 }}>
                        Catalogue, stock et prix négociés en temps réel. Commandez 24/7.
                    </Typography>
                </Box>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)' }}>
                    Besoin d'un compte? Contactez votre représentant Amabec.
                </Typography>
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    px: { xs: 3, md: 6 },
                    py: 5,
                    backgroundColor: b2bColors.surfaceAlt,
                }}
            >
                <Paper sx={{ width: '100%', maxWidth: 420, p: { xs: 3, md: 4 } }}>
                    <Typography variant="h2" sx={{ mb: 1 }}>{title}</Typography>
                    {subtitle ? (
                        <Typography variant="body2" sx={{ mb: 3 }}>{subtitle}</Typography>
                    ) : <Box sx={{ mb: 2 }} />}
                    {children}
                </Paper>
            </Box>
        </Box>
    );
}
